import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import uuid from 'react-uuid';
import TranslationService from './../../Services/translationService';
import ApiService from './../../Services/apiService';
import AlertService from '../../Services/alertService';
import { ERROR_KEY, SUCCESS_KEY } from '../../Constants/mainKeys';
import { addPartialViewSpinner, removePartialViewSpinner, addButtonSpinner, removeButtonSpinner } from './../../Store/Actions/spinner';
import ArrowBackSvg from '../../Components/Svg/arrowBackSvg';
import { Link, withRouter } from 'react-router-dom';
import Input from "../../Components/Inputs/input";
import ReactSelectOption from '../../Components/SelectOption/reactSelectOption';
import ActionButton from '../../Components/ActionButton/actionButton';
import { GROUP_FORM_KEY, GROUP_KEY } from '../../Constants/urlKeys';

const GroupForm = (props) => {

  const spinnerId = uuid();
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translation.translations);
  const language = useSelector(state => state.language.language);

  const [translationService, setTranslationService] = useState(null);
  const nameMaxLength = 200;
  const groupId = props.match.params.groupId;
  const [organizationEducationalLevels, setOrganizationEducationalLevels] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [directions, setDirections] = useState([]);
  const [programNames, setProgramNames] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [defaultValue, setDefaultValue] = useState("");
  const [isInvalidSubmit, setIsInvalidSubmit] = useState(false);

  // const [curatorId, setCuratorId] = useState(null);
  const [levelId, setLevelId] = useState(null);
  const [programId, setProgramId] = useState(null);
  const [directionId, setDirectionId] = useState(null);
  const [programNameId, setProgramNameId] = useState(null);
  const [ownerUserId, setOwnerUserId] = useState(null);

  useEffect(() => {
    setTranslationService(new TranslationService(translations));
  }, [translations]);

  useEffect(() => {
    getOrganizationEducationalLevels();
  }, []);

  useEffect(() => {
    props.match.params.groupId && getGroupById(groupId);
  }, [props.match.params.groupId]);

  const getGroupById = (groupId) => {
    const spinnerId = uuid();
    dispatch(addPartialViewSpinner(spinnerId));
    ApiService.getGroupById(groupId).then(response => {
      if (response.data) {
        const data = { ...response.data };
        setGroupName(data.groupName);
        setProgramNameId(data.organizationEducationLevelId);
        // setDefaultValue({ label: data.organizationEducationLevelName, value: data.organizationEducationLevelId });
        setDefaultValue(data.organizationEducationLevelName);
        setOwnerUserId(data.ownerUserId)
        dispatch(removePartialViewSpinner(spinnerId));
      }
    }).catch(error => {
      getFail(error, spinnerId);
      props.history.push(`/${language}/${GROUP_FORM_KEY}`);
    });
  }

  const getOrganizationEducationalLevels = () => {
    const spinnerId = uuid();
    dispatch(addPartialViewSpinner(spinnerId));
    ApiService.getOrganizationEducationalLevels().then(response => {
      if (response.data) {
        setOrganizationEducationalLevels(response.data);
      }
      dispatch(removePartialViewSpinner(spinnerId))
    }).catch(error => getFail(error, spinnerId));
  }

  const onSelectChangeWithOutRequest = (selectedCategory, cb) => {
    if (!selectedCategory) { return; }
    cb(selectedCategory.id);
  }

  const onLevelChange = (selectedCategory, cb) => {
    if (!selectedCategory) { return; }
    cb(selectedCategory.id);
    setDefaultValue("");
    setProgramId(null);
    setProgramNames([]);
    setDirectionId(null);
    setDirections([]);
    setProgramNameId(null);
    setIsInvalidSubmit(false);
    ApiService.getOrganizationEducationalLevelsById(selectedCategory.id).then(response => {
      if (response.data) { setPrograms(response.data) }
    }).catch(error => getFail(error, null));
  }

  const onProgramChange = (selectedCategory, cb) => {
    if (!selectedCategory) { return; }
    cb(selectedCategory.id);
    setDirectionId(null);
    setProgramNameId(null);
    setProgramNames([]);
    setIsInvalidSubmit(false);
    ApiService.getOrganizationEducationalLevelsById(selectedCategory.id).then(response => {
      if (response.data) { setDirections(response.data) }
    }).catch(error => getFail(error, null));
  }

  const onDirectionChange = (selectedCategory, cb) => {
    if (!selectedCategory) { return; }
    cb(selectedCategory.id);
    ApiService.getOrganizationEducationalLevelsById(selectedCategory.id).then(response => {
      if (response.data) { setProgramNames(response.data) }
    }).catch(error => getFail(error, null));
  }

  const onChange = (event, maxLength = null) => {
    if (maxLength && maxLength < event.target.value.length) { return; }
    setGroupName(event.target.value);
    setIsInvalidSubmit(false);
  };

  const getFail = (error, spinnerId) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
    spinnerId && dispatch(removePartialViewSpinner(spinnerId));
    spinnerId && dispatch(removeButtonSpinner(spinnerId));
  }

  const onSubmit = (event) => {
    event && event.preventDefault();
    if (groupId && (!groupName || !groupName.trim() || !programNameId)) {
      setIsInvalidSubmit(true);
      return;
    }
    if (!groupId && (!levelId || !programId || !directionId || !programNameId || !groupName || !groupName.trim())) {
      setIsInvalidSubmit(true);
      return;
    }
    const data = {
      groupName: groupName.trim(),
      organizationEducationLevelId: programNameId
    }
    if (groupId) {
      data.id = +groupId;
      data.ownerUserId = +ownerUserId
    }
    dispatch(addButtonSpinner(spinnerId));
    (groupId ? ApiService.updateGroup(data) : ApiService.createGroup(data)).then(() => {
      groupId && AlertService.alert(SUCCESS_KEY, translationService.translate("TR_GROUP_SUCCESSFULLY_UPDATED"));
      !groupId && AlertService.alert(SUCCESS_KEY, translationService.translate("TR_GROUP_SUCCESSFULLY_CREATED"));
      dispatch(removeButtonSpinner(spinnerId));
      props.history.push(`/${language}/${GROUP_KEY}`);
    }).catch(error => getFail(error, spinnerId));
  }

  return translationService && organizationEducationalLevels && organizationEducationalLevels.length ?
    <div className="container">
      <div className="row">
        <div className="col-12 content-title">
          <div className="d-flex align-items-center">
            <Link to={`/${language}/${GROUP_KEY}`} title={translationService.translate("TR_BACK")}><ArrowBackSvg /></Link>
            <h2 className="content-title p-0">
              {
                groupId ? translationService.translate("TR_UPDATE_GROUP") : translationService.translate("TR_CREATE_GROUP")
              }
            </h2>
          </div>
        </div>
      </div>
      <hr />
      <form onSubmit={onSubmit}>
        <div className="row">
          <div className="col-md-6 col-12 my-1">
            <Input
              type="text"
              id="groupName"
              name="groupName"
              inputClassName="pr--4"
              value={groupName}
              fieldLength={nameMaxLength}
              isInvalidSubmit={isInvalidSubmit}
              isInvalidField={isInvalidSubmit && !groupName.trim()}
              labelValue={`${translationService.translate("TR_GROUP_NAME")} *`}
              onChange={event => onChange(event, nameMaxLength)}
            />
          </div>
          <div className="col-md-6 col-12 my-1">
            <label>{`${translationService.translate("TR_LEVEL")} *`}</label>
            <ReactSelectOption
              value={levelId}
              isInvalidSubmit={isInvalidSubmit}
              selectedValue={(() => {
                const selectedItem = { ...organizationEducationalLevels.find(data => +data.id === +levelId) };
                if (selectedItem) {
                  selectedItem.label = translationService.translate(selectedItem.name) ? translationService.translate(selectedItem.name) : selectedItem.name;
                  selectedItem.value = selectedItem.id;
                }
                return selectedItem;
              })()}
              items={organizationEducationalLevels.map(data => ({ ...data, label: translationService.translate(data.name) ? translationService.translate(data.name) : data.name, value: data.id }))}
              onChange={(item) => onLevelChange(item, setLevelId)}
            />
          </div>
          <div className="col-md-6 col-12 my-1">
            <label>{`${translationService.translate("TR_PROGRAM")} *`}</label>
            <ReactSelectOption
              value={programId}
              isDisabled={!programs || !programs.length}
              selectedValue={(() => {
                const selectedItem = { ...programs.find(data => +data.id === +programId) };
                if (selectedItem) {
                  selectedItem.label = translationService.translate(selectedItem.name) ? translationService.translate(selectedItem.name) : selectedItem.name;
                  selectedItem.value = selectedItem.id;
                }
                return selectedItem;
              })()}
              isInvalidSubmit={isInvalidSubmit}
              items={programs.map(data => ({ ...data, label: translationService.translate(data.name) ? translationService.translate(data.name) : data.name, value: data.id }))}
              onChange={(item) => onProgramChange(item, setProgramId)}
            />
          </div>
          <div className="col-md-6 col-12 my-1">
            <label>{`${translationService.translate("TR_DIRECTION")} *`}</label>
            <ReactSelectOption
              value={directionId}
              isDisabled={!directions || !directions.length}
              selectedValue={(() => {
                const selectedItem = { ...directions.find(data => +data.id === +directionId) };
                if (selectedItem) {
                  selectedItem.label = translationService.translate(selectedItem.name) ? translationService.translate(selectedItem.name) : selectedItem.name;
                  selectedItem.value = selectedItem.id;
                }
                return selectedItem;
              })()}
              isInvalidSubmit={isInvalidSubmit}
              items={directions.map(data => ({ ...data, label: translationService.translate(data.name) ? translationService.translate(data.name) : data.name, value: data.id }))}
              onChange={(item) => onDirectionChange(item, setDirectionId)}
            />
          </div>
          {
            // (groupId && defaultValue) || (!groupId && !defaultValue) ?
            <div className="col-md-6 col-12 my-1">
              <label>{`${translationService.translate("TR_PROGRAM_NAME")} *`}</label>
              <ReactSelectOption
                value={programNameId}
                isDisabled={!programNames || !programNames.length}
                isInvalidSubmit={isInvalidSubmit}
                // defaultValue={defaultValue}
                selectedValue={(() => {
                  const selectedItem = { ...programNames.find(data => +data.id === +programNameId) };
                  if (selectedItem) {
                    selectedItem.label = translationService.translate(selectedItem.name) ? translationService.translate(selectedItem.name) : selectedItem.name;
                    selectedItem.value = selectedItem.id;
                  }
                  return selectedItem;
                })()}
                placeholder={defaultValue ? defaultValue : ""}
                items={programNames.map(data => ({ ...data, label: translationService.translate(data.name) ? translationService.translate(data.name) : data.name, value: data.id }))}
                onChange={(item) => onSelectChangeWithOutRequest(item, setProgramNameId)}
              />
            </div>
            // : null
          }
          <div className="col-12">
            <div className="mt-3">
              <ActionButton
                spinnerId={spinnerId}
                type="submit"
                className="mindalay--btn-dark position-relative"
                name={translationService.translate(!groupId ? "TR_CREATE" : "TR_UPDATE")}
              />
            </div>
          </div>
        </div>
      </form>
    </div> : null
}
export default withRouter(GroupForm)
